import { Property } from '../../types/property';

export const ELIGIBILITY_CRITERIA_ACCOUNT_NUMBER = 'ST0626203';
export const ELIGIBILITY_CRITERIA_URL = 'https://mapleandmay.co.uk/affordable-rent';

const requiresEligibilityConfirmation = (property?: Property) => {
  return property?.account?.accountNumber === ELIGIBILITY_CRITERIA_ACCOUNT_NUMBER;
};

export default requiresEligibilityConfirmation;
